// BANNER
export const TITLE = <div>Delivery Consultant enablement</div>;

// INSTRUCTIONS
export const GOALS = "Learn how to implement and deploy Dynatrace at scale with best-practices and to provide consultancy services.";
export const HOW = "The training is free and includes and includes both self-paced courses and instructor-led sessions.";
export const WHAT = "You can start this training without any pre-requisites, a technical background is a must.";
export const REQUIREMENTS = " You must hold an active Associate Certification to take part in the Professional Certification bootcamp.";

// BADGE

const ASSOCIATE_COVER_1 = "Architecture and components";
const ASSOCIATE_COVER_2 = "Installation and configuration";
const ASSOCIATE_COVER_3 = "Hands-on labs";
const ASSOCIATE_COVER_4 = "Study quizzes";
export const ASSOCIATE_COVERS: String[] = [ASSOCIATE_COVER_1, ASSOCIATE_COVER_2, ASSOCIATE_COVER_3, ASSOCIATE_COVER_4];

const PROFESSIONAL_COVER_1 = "Advanced configuration";
const PROFESSIONAL_COVER_2 = "APIs and integrations";
const PROFESSIONAL_COVER_3 = "Advanced hands-on labs";
const PROFESSIONAL_COVER_4 = "Advanced study quizzes";
export const PROFESSIONAL_COVERS: String[] = [PROFESSIONAL_COVER_1, PROFESSIONAL_COVER_2, PROFESSIONAL_COVER_3, PROFESSIONAL_COVER_4];


// ACHIEVEMENTS
export const ACHIEVEMENTS = <div >
                        ·&nbsp;&nbsp; Upon completion of this training, you will have the skills required to become a highly effective 
                        &nbsp;&nbsp;&nbsp;Dynatrace power user. You will also be well-prepared to take the written and practical
                        &nbsp;&nbsp;&nbsp;Professional Certification exams.
                        <br></br>
                        <br></br>
                        ·&nbsp;&nbsp; After getting Professional Certified, you will receive an invitation to join the Partner Pro Club. As a 
                        &nbsp;&nbsp;&nbsp;member of the Partner Pro Club, you will receive goodies and get invited to exclusive events and 
                        &nbsp;&nbsp;&nbsp;training sessions.
                        <br></br>
                    </div>;
// -- 


// FAQs
export const TITLE_ONE = "Access the Demo environment";
export const TITLE_TWO = "Webinars";
// export const TITLE_THREE = "What certifications are available for technical resources?";
// export const TITLE_FOUR = "Can I get the certification exam for free?";

export const SUB_TITLE_ONE = <div>Access the <a href="https://demo.live.dynatrace.com/?_ga=2.144199989.1015536957.1688374650-866963118.1687356289">Demo environment</a> , where you can practice your skills. </div>;
export const SUB_TITLE_TWO = <div>Get in touch with our experts to get most out of the Dynatrace software intelligence platform: <a href="https://www.dynatrace.com/news/webinar/">Dynatrace webinars</a>. </div>;
// export const SUB_TITLE_THREE = "Our product certification program for Technical resources has 3 levels: Associate, Professional, and Master. More details on the different product certifications can be found on Dynatrace University.";
// export const SUB_TITLE_FOUR = "The technical exams are proctored by an external company that monitors trainees throughout the exam via their webcam. The price of the exam is related to the cost of this exam proctoring. You can get a free exam voucher by completing all labs during the Dynatrace Associate Certification Bootcamp or by attending events like Perform and Amplify. On top of that, Dynatrace will fund the cost of a repeat exam for trainees that got more than 68% on their first paid exam attempt.";

// --



